import React from 'react';
import PropTypes from 'prop-types';
import BaseProgressBar from './BaseProgressBar';

const ProgressBar = ({ widthPct = 100, className = '' }) => {
  const widthStyle = { width: `${widthPct}%` };

  return <BaseProgressBar className={className} widthStyle={widthStyle} />;
};

ProgressBar.propTypes = {
  widthPct: PropTypes.number,
  className: PropTypes.string,
};

export default ProgressBar;
